import { TranslateService } from '@ngx-translate/core';
import { Component, Input, OnInit } from '@angular/core';
import { AdvancedSearchService } from '@app/_services';
import { HomepageService } from '@app/_services/homepage.service';
import { SharedService } from '@app/_services/shared.service';
import { Support, TranslateHelper } from '@app/_helpers';
import * as _ from 'lodash';
import { Router, ActivatedRoute } from '@angular/router';
import { NgClass } from '@angular/common';


@Component({
    selector: 'app-section-card',
    templateUrl: './section-card.component.html',
    styleUrls: ['./section-card.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgClass]
})
export class SectionCardComponent implements OnInit {
    constructor( private homepageService:HomepageService,
        private sharedService:SharedService,
        private router:Router,
        private route:ActivatedRoute,
        public translateHelper: TranslateHelper,
        public translate: TranslateService
    ) { }


    @Input() section: any;
    @Input() searchParams: any;
    @Input() layout: 'grid-sm' | 'grid-nl' | 'grid-lg' | 'list' | 'horizontal' | null = null;
    sector;

    ngOnInit(): void {
         this.sharedService.page$.subscribe(page=> this.sector = page);
    }


    routerLinkString() {
        return ['/sector', this.section.sector?.seo?.slug,`/${this.section.type}`, this.section?.seo?.slug];
    }

    search(){

        let params = {
            sector: this.sector,
            properties:this.searchParams?.properties,
            subtypeId: this.searchParams?.subtypeId

        }

        let properties = [];
        _.forEach(this.searchParams?.properties, element => {
            if (element.value) properties.push({
                propertyId : element.propertyId,
                value :element.value

            });
        });

        let url = this.router
            .createUrlTree([this.router.url, 'search'], {
                relativeTo: this.route
            })
            .toString();
        params = _.merge(params, { properties: properties });
        url += `?${Support.toQueryParams(params)}`;
        this.router.navigateByUrl(url);

    }


}
